export const StopDescriptionModals = {
    MORE_DESCRIPTION: 'More Description',
    MEDIA_VIEW: 'Media View',
}
